import { SalesforceBase } from './salesforce-base.model';

export interface RecordType extends SalesforceBase {
  developername: string;
  isactive?: boolean;
}

export enum RecordTypeName {
  NOC = 'NOC',
  Care = 'Care',
  Finance = 'Finance',
  Maintenance = 'Maintenance',
  Proactive = 'Proactive',
  NonProactive = 'NonProactive',
  Support = 'Support',
}
